import { useRouter } from 'next/router';
import { usePageFiltersContext } from '@/creditflowresearch/application/PageFilters/PageFiltersContext';
import { getPageIsOpened } from '@/creditflowresearch/application/ArticlesAndStats/ArticlesSubscriptions/helpers';

export const usePageSubscriptionState = () => {
  const { query } = useRouter();
  const { companyViewId, sector: querySector, industry: queryIndustry } = query;
  const { pageFilters } = usePageFiltersContext();
  const { productIds, regionIds } = pageFilters;

  const isOneFilterSelected = productIds.length === 1 && regionIds.length === 1;
  const isCommonButtonUsed = !!companyViewId || !!querySector || !!queryIndustry;
  const activePage = getPageIsOpened(query);

  return {
    isOneFilterSelected,
    isCommonButtonUsed,
    activePage,
  };
};
